import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";
import {Link} from "react-router-dom"

const caseStudies = [
  {
    id: 1,
    title: "Startup X Saves 40% Time on Accounting",
    summary:
      "By switching to our AI accountant, Startup X automated bookkeeping and reduced manual errors, saving 40% of their accounting time.",
  },
  {
    id: 2,
    title: "Company Y Ensures 100% Compliance",
    summary:
      "Company Y integrated AI compliance tracking and never missed a statutory deadline, avoiding fines and penalties.",
  },
  {
    id: 3,
    title: "SME Z Gains Real-Time Insights",
    summary:
      "SME Z used AI-generated balance sheets and cash flow predictions to make faster and smarter financial decisions.",
  },
];

const CaseStudy = () => {
  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Header */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: "primary.main",
            fontWeight: "bold",
            mb: 6,
          }}
        >
          Case Studies
        </Typography>

        {/* Case Study Cards */}
        <Grid container spacing={4}>
          {caseStudies.map((study) => (
            <Grid item xs={12} sm={6} md={4} key={study.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", mb: 1, color: "primary.main" }}
                  >
                    {study.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {study.summary}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    sx={{ textTransform: "none", fontWeight: "bold" }}
                  >
                    Read More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* CTA Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 8,
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Want results like these for your business?
          </Typography>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="primary"
            size="large"
            sx={{ px: 4, py: 1.5, borderRadius: 2, textTransform: "none" }}
          >
            Start Your AI Accounting Journey
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default CaseStudy;
